import { getRegisterQuery } from '@/assets/js/util'

export const toRegisterMixin = {
  methods: {
    toRegisterPage(route) {
      // 获取跳转注册页要带的query
      let query = getRegisterQuery(route)
      this.$router.push({
        name: 'register',
        query
      })
    }
  }
}
export const registerMixin = {
  data() {
    return {
      phone: '',
      second: 60,
      code: '',
      canGetRandCode: true,
      tipText: ''
    }
  },
  methods: {
    submit() {
      // 手机号
      if (!this.phone) {
        this.showTip('请输入手机号')
        return
      }
      if (!this.phone.match(/^1\d{10}$/gi)) {
        this.showTip('手机号不正确')
        return
      }
      if (!this.code) {
        this.showTip('请输入短信验证码')
        return
      }
      if (!this.isCheck && !isWechatSubscription && this.$route.name === 'register') {
        this.showTip('请已阅读并同意用户协议与隐私保护政策')
        return
      }
      this.register()
    },
    toNextPage() {
      switch (this.$route.query.version) {
        case 'NEW':
          var { return_url: name } = this.$route.query
          let params = {}
          if (this.$route.query.params) {
            let str = this.$route.query.params.split('_')
            params = { [str[0]]: str[1] }
            delete this.$route.query.params
          }
          // var id = this.$route.query.id
          delete this.$route.query.return_url
          delete this.$route.query.version
          // delete this.$route.query.id;
          this.$router.replace({
            name: name,
            query: this.$route.query,
            params
          })
          break
        case 'OLD':
          location.replace(decodeURIComponent(this.$route.query.return_url))
          break
        default:
          if (history.length < 2) {
            this.$router.push('/')
          } else {
            // 判断上一页是否授权页，避免死循环
            if (/\/auth_entrance/.test('/auth_entrance')) {
              this.$router.replace('/')
              return;
            }
            this.$router.back()
          }

          break
      }
    },

    coundown() {
      setTimeout(() => {
        if (this.second <= 0) {
          this.second = 60
          this.canGetRandCode = true
          return
        }
        this.second--
        this.coundown()
      }, 1000)
    },
    showTip(text) {
      this.tipText = text
      this.$refs.topTip.show()
    }
  },
  submit() {
    // 检查表单
    // 手机号
    if (!this.phone) {
      this.showTip('请输入手机号')
      return
    }
    if (!this.phone.match(/^1\d{10}$/gi)) {
      this.showTip('手机号不正确')
      return
    }
    if (!this.code) {
      this.showTip('请输入短信验证码')
      return
    }
    this.register()
  }
}
